// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__3CwP0","container":"Dashboard_container__KJRIj","Menu":"Dashboard_Menu__2OygY"};